import { useEffect } from 'react';
import { useAuth } from '@/stores/auth';
import {
  registerPushIfPermitted,
  subscribeForegroundPushMessages,
} from '@/lib/pushNotifications';

/** Keeps FCM token in sync and shows foreground push toasts. */
export function PushRegistration() {
  const firebaseUser = useAuth((s) => s.firebaseUser);
  const pushOn = useAuth((s) => s.userDoc?.preferences?.notificationChannels?.push ?? true);

  useEffect(() => {
    if (!firebaseUser) return;
    return subscribeForegroundPushMessages();
  }, [firebaseUser?.uid]);

  useEffect(() => {
    if (!firebaseUser || !pushOn) return;
    void registerPushIfPermitted();
  }, [firebaseUser?.uid, pushOn]);

  return null;
}
